var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFooter)?_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__liha"},[_c('vue-markdown',{attrs:{"source":_vm.footerText}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }